import React from 'react'
//import {Link} from 'gatsby';
import Container from './Container'

import './Wrapper.css'

const wrapper = props => {
  let classes = ['wrapper']
  //console.log(props);
  if (props.styles) {
    classes = classes.concat(props.styles);
  }

  return (
    <section className={classes.join(' ')}>
      <Container 
        headerProps={props.header}
        items={props.items}
        layout={props.containerLayout}
      />
    </section>
  );
};

export default wrapper
